<script setup lang="ts">
import SearchIcon from '@/assets/icons/search.svg?component'
import { debounce } from '@/lib/helpers'
import { InputComponent } from '@/ui-library'

defineProps<{
  placeholder: string
}>()

const query = defineModel<string>('query')
const handleSearchQuery = debounce((str: string) => (query.value = str), 300)
</script>
<template>
  <InputComponent
    :model-value="query"
    :placeholder="placeholder"
    size="small"
    maxlength="100"
    class="query-selector"
    @input="handleSearchQuery"
  >
    <template #prefix>
      <el-icon :size="24">
        <SearchIcon />
      </el-icon>
    </template>
  </InputComponent>
</template>
<style lang="scss" scoped>
.query-selector {
  min-width: 280px;

  @media screen and (max-width: 767px) {
    min-width: 100%;
  }
}

:deep(.el-input--small .el-input__wrapper) {
  padding: 8px;
}
</style>
